export default __webpack_public_path__ + "static/media/sheep_roller.b89ed00a.pdf";